import $ from 'jquery';
import anime from 'animejs';
import { getWidth } from '../utils/window';

export default function home() {
    const $html = $('html');
    
    // if desktop only
    let heroImages = anime({
        targets: '#hero .hero_image',
        translateX: ['100%', 0],
        opacity: [0, 1],
        duration: 700,
        easing: 'easeInOutQuart',
        delay: function(el, i, l) {
            return i * 550;
        }
    });
}



// WEBPACK FOOTER //
// ./source/scripts/pages/homepage.js